module.exports = __webpack_public_path__ + "static/img/z5.2a50a8e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/iot/z5.png
// module id = y36A
// module chunks = 0